import $ from "jquery";

import f from "../funcs";
import Events from "./Events";
import Backbone from "backbone";
import Marionette from "marionette";
import "plugins/tinyscrollbar";


function hasDividerClassName(model) {
    let className = (model.get("className") || "");
    return /divider/.test(className);
}

let $globalBox = $("<div class='contextmenus'/>").appendTo("body");
let index = 0;
let ContextMenuView = Marionette.CollectionView.extend("ContextMenuView", {
    childView: Marionette.ItemView.extend(),

    events: {
        "click a": "onItemClick",
        "mousedown a": "onItemMousedown"
    },

    initialize(params) {
        let that = this;
        this.addClassName = params.addClassName;
        this.index = ++index;
        this._preventShow = false;
        this.params = params;

        this.eva = new Events();

        let noAutoParam = { collection: 1, listenElem: 1 };
        for (let key in params) {
            if ( !noAutoParam[key] ) {
                this[key] = params[key];
            }
        }

        that.createElement();
        this.eva.listenTo($(window), "mousedown touchstart", (e) => {
            if ( that.scroll && that.scroll.checkInDrag() ) {
                return;
            }

            if ( !that.isInnerElem(e.target) ) {
                that.hide();
            }
        });

        this.listenElem(params.listenElem, params.touchOpenTimeout || 1000);
        this.x = 0;
        this.y = 0;
        this.h = 0;
        this.w = 0;
        this.initMaxHeight();
    },

    isInnerElem(el) {
        if (
            f.isFunction(this.params.isInnerElem)
                && this.params.isInnerElem(el)
        ) {
            return true;
        }

        let isInnerTarget = false;
        let childMenuEl;

        if ( this.childMenu instanceof ContextMenuView ) {
            childMenuEl = this.childMenu.el;
        }

        while (
            el
                && el.parentNode
        ) {
            if ( el == this.el || el == childMenuEl ) {
                isInnerTarget = true;
                break;
            }
            el = el.parentNode;
        }

        return isInnerTarget;
    },

    listenElem(listenElem, timeout = this.params.touchOpenTimeout || 1000) {
        let $listenElem;
        if ( !(listenElem instanceof Element) ) {
            return;
        }

        $listenElem = $(listenElem);

        this.eva.listenTo($listenElem, "contextmenu", (e) => {
            if ( !this._beforeShow(e) ) {
                return;
            }

            e.stopPropagation();
            e.preventDefault();

            this.moveTo(e.pageX - 5 , e.pageY - 5);
            this.show();
        });

        this.eva.listenTo($listenElem, "touchstart", (e) => {
            clearTimeout(this._touchTimer);

            this._touchTimer = setTimeout(() => {
                if ( !this._beforeShow(e) ) {
                    return;
                }

                let point = f.getTouchPoint(e);
                this.moveTo(point.x - 5, point.y - 5);
                this.show();
            }, timeout);
        });

        this.eva.listenTo($listenElem, "touchmove", () => {
            clearTimeout(this._touchTimer);
            this.hide();
        });
    },

    _beforeShow(e) {
        this.trigger("beforeShow", e);

        const getContextItems = (
            this.params.getContextItems
            || this._context && this._context.getContextItems
        );
        if ( f.isFunction(getContextItems) ) {
            this.collection.reset();

            const items = getContextItems(e);
            if ( f.isArray(items) && items.length ) {
                this.collection.set(items);
            }
            this.render();
        }

        if ( e instanceof window.MouseEvent || this.collection.length === 0 ) {
            return false;
        }

        if ( /textarea|input/.test(e.target.tagName.toLowerCase()) ) {
            return false;
        }

        return true;
    },

    createElement() {
        let el = document.createElement("ul");
        let style = el.style;

        el.className = "dropdown-menu context-menu tab-area";
        el.id = "js-context-menu-" + this.cid;
        style.position = "absolute";
        style.display = "block";
        style.left = "0";
        style.top = "0";
        style.visibility = "hidden";

        $globalBox.append(el);
        el = document.getElementById(el.id);

        this.setElement(el);
        this.$el.data("tab-area", this);
    },

    moveTo(x, y) {
        let windowSize = f.getWindowSize();
        let windowWidth = windowSize.width;
        let windowHeight = windowSize.height;

        if ( x + this.w > windowWidth ) {
            x = windowWidth - this.w - 3;
        }
        if ( y + this.h > windowHeight ) {
            y = windowHeight - this.h - 3;
        }

        this.x = x;
        this.y = y;
        this.el.style.left = x + "px";
        this.el.style.top = y + "px";
    },

    show() {
        // не открываем меню, если нет элементов
        if ( this.collection.length === 0 ) {
            return;
        }

        if ( this._preventShow ) {
            this._preventShow = false;
            return;
        }

        // исправляем баг: при первом открытии меню, оно выходит за границы окна
        // moveTo сделает проверку
        this.moveTo(this.x, this.y);

        this.el.style.visibility = "visible";
        this.trigger("show");

        this._showed = true;
    },

    preventShow() {
        this._preventShow = true;
    },

    hide() {
        this.el.style.visibility = "hidden";
        clearTimeout(this._touchTimer);
        this._showed = false;
        this.trigger("hide");
    },

    render() {
        let that = this;
        let html = [];

        if ( this.addClassName ) {
            this.$el.addClass(this.addClassName);
        }

        // фильтруем скрытые
        let models = that.collection.models.filter(function(model) {
            return model && model.get("display") != "none";
        });

        // фильтрует подрядидущие разделитель
        models = models.filter(function(model, i) {
            let nextModel = models[ i + 1 ];
            let isDivider = hasDividerClassName(model);
            let nextIsDivider = nextModel && hasDividerClassName(nextModel);

            return !isDivider || !nextIsDivider;
        });

        // убираем первый дивидер
        let firstModel = models[ 0 ];
        if ( firstModel && hasDividerClassName(firstModel) ) {
            models.shift();
        }

        // убираем последний дивидер
        let lastModel = models[ models.length - 1 ];
        if ( lastModel && hasDividerClassName(lastModel) ) {
            models.pop();
        }

        html = models.map(
            that.getChildHTML.bind(that)
        ).join("");

        if ( this.maxHeight ) {
            html = [
                "<div class='viewport'>",
                "<div class='overview'>",
                html,
                "</div>",
                "<div class='scrollbar scrollbar-y'>",
                "<div class='track'>",
                "<div class='thumb'>",
                "</div>",
                "</div>",
                "</div>",
                "</div>"
            ].join("");
        }

        this.el.innerHTML = html;

        this.h = this.el.offsetHeight;
        this.w = this.el.offsetWidth;
        this.$el.css("z-index", this.zIndex || 1000000);

        if ( this.maxHeight ) {
            this.$el.data("plugin_tinyscrollbar", false);
            this.$el.tinyscrollbar();
            this.scroll = this.$el.data("plugin_tinyscrollbar");
        }
    },

    getChildHTML(model) {
        let className = model.get("className") || "";
        if ( className.indexOf("divider") == -1 ) {
            className += " tab-elem";
        }
        return [
            // item-model.get("title") нужно для e2e тестов
            "<li class='" + className + "' item-'" + model.get("title") + "' " + (
                model.get("display") == "none"
                    ? "style=\"display:none\""
                    : ""
            ) + ` mid=${model.id}>`,
            "<a cid='" + model.cid + "'>",
            model.get("name"),
            "</a>",
            "</li>"
        ].join("");
    },

    onItemClick(e) {
        let $a = $(e.currentTarget);
        let cid = $a.attr("cid");
        let model = this.collection.get(cid);

        if ( !model ) {
            return;
        }

        e.preventDefault();
        this.trigger("itemClick", e, model);

        let onClick = model.get("onClick");
        if ( this._context && f.isString(onClick) ) {
            onClick = this._context[onClick];
        }

        if ( f.isFunction(onClick) ) {
            const result = onClick.call(this._context, e, model);
            if ( result !== false ) {
                this.hide();
            }
        }
    },

    onItemMousedown(e) {
        let $a = $(e.currentTarget);
        let cid = $a.attr("cid");
        let model = this.collection.get(cid);

        if ( !model ) {
            return;
        }

        e.preventDefault();
        this.trigger("itemMousedown", e, model);

        if ( this._context ) {
            let onMousedown = model.get("onMousedown");
            let result;

            if ( f.isString(onMousedown) ) {
                onMousedown = this._context[onMousedown];
            }

            if ( f.isFunction(onMousedown) ) {
                result = onMousedown.call(this._context, e, model);
                if ( result !== false ) {
                    this.hide();
                }
            }
        }
    },

    initMaxHeight() {
        if ( !f.isNumber(this.maxHeight) || this.maxHeight <= 0 ) {
            return;
        }

        this.$el
            .css({ "max-height": this.maxHeight + "px" })
            .addClass("max-height");
    },

    focusEnter($elem) {
        $elem.find("a").click();
    },

    isShowed() {
        return !!this._showed;
    },

    destroy() {
        this.eva.destroy();
        if ( this.$el ) {
            this.$el.data("tab-area", false);
            if ( this.el.parentNode ) {
                this.el.outerHTML = "";
            }
        }
        ContextMenuView.__super__.destroy.apply(this);
    }
});

ContextMenuView.initContextMenu = function(el) {
    this.contextmenuCollection = new Backbone.Collection();
    this.contextmenuCollection.set(this.getContextItems($.Event("initContextMenu")));

    this.contextmenu = new ContextMenuView({
        icon: this,
        collection: this.contextmenuCollection,
        listenElem: this.el || this.box || el,
        touchOpenTimeout: 1500
    });
    this.contextmenu.render();
    this.contextmenu._context = this;
};

export default ContextMenuView;
